/* eslint-disable jsx-a11y/no-static-element-interactions */
import classNames from 'classnames';
import React, { useState } from 'react';

import { RicosAlignmentContextProvider, RicosNodeContextProvider } from './../../ricos-context';
import type { NodeViewRendererProps } from './../../ricos-types';

import { ROOT } from '../data-hooks';
import collapsibleListStyles from '../statics/styles/collapsible-list-component.rtlignore-scss';
import { getAlignmentFromDirection } from '../utils';
import { CollapsibleListContextProvider } from './collapsibleListContext';

const CollapsibleList = ({
  node,
  nodeIndex,
  RicosNodesRenderer,
  NodeViewContainer,
}: NodeViewRendererProps) => {
  const [expandedItemId, setExpandedItemId] = useState<string | undefined>(undefined);

  const styles = collapsibleListStyles;

  const direction = node.collapsibleListData?.direction?.toLowerCase() || 'ltr';
  const alignment = getAlignmentFromDirection(direction);

  return (
    <NodeViewContainer node={node} nodeIndex={nodeIndex}>
      <div className={classNames(styles[direction], styles.listDimensions)} data-hook={ROOT}>
        <RicosAlignmentContextProvider textAlignment={alignment}>
          <RicosNodeContextProvider parentNode={node} parentIndex={nodeIndex}>
            <CollapsibleListContextProvider
              expandedItemId={expandedItemId}
              setExpandedItemId={setExpandedItemId}
            >
              <RicosNodesRenderer nodes={node.nodes ?? []} />
            </CollapsibleListContextProvider>
          </RicosNodeContextProvider>
        </RicosAlignmentContextProvider>
      </div>
    </NodeViewContainer>
  );
};

const CollapsibleListRenderer = ({ node, ...props }: NodeViewRendererProps) => {
  return <CollapsibleList key={node.id} node={node} {...props} />;
};

export default CollapsibleListRenderer;
